import { Heading, Stack, StackProps } from "@chakra-ui/react";
import * as React from "react";

interface StepContentProps extends StackProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export function StepContent({
  title,
  subtitle,
  children,
  ...props
}: StepContentProps) {
  return (
    <Stack flex="1" gap="4" {...props}>
      <Stack gap={subtitle ? "0" : "4"}>
        <Heading>{title}</Heading>
        {subtitle && (
          <Heading color="fg.muted" fontWeight="medium" size="xs">
            {subtitle}
          </Heading>
        )}
      </Stack>
      {children}
    </Stack>
  );
}
